import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import axios from "axios";

const API = "https://backendlab.vercel.app";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const PatientForm = ({ isOpen, onRequestClose, initialData, fetchPatients, fetchAppointments }) => {
  const [activeTab, setActiveTab] = useState("geral");

  const [name, setName] = useState("");
  const [assistantName, setAssistantName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [typeOfWork, setTypeOfWork] = useState("");
  const [laboratorio, setLaboratorio] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [notes, setNotes] = useState("");
  const [cor, setCor] = useState("");
  const [cor2, setCor2] = useState("");
  const [material2, setMaterial2] = useState("");
  const [material, setMaterial] = useState("");
  const [externalDetails, setExternalDetails] = useState("");
  const [dentes, setdentes] = useState("");
  const [tipoDentes, setTipoDentes] = useState("");
  const [software, setSoftware] = useState("");
  const [goteiraType, setGoteiraType] = useState("");

  // Photos: existing (from DB) and pending (new files not yet uploaded)
  const [existingPhotos, setExistingPhotos] = useState([]);
  const [pendingPhotos, setPendingPhotos] = useState([]); // File objects
  const [uploadingPhotos, setUploadingPhotos] = useState(false);

  const fileInputRef = useRef(null);

  const [concertoForm, setConcertoForm] = useState({ patientName: "", date: "", hour: "", minute: "", notes: "" });

  useEffect(() => {
    setActiveTab("geral");
    setConcertoForm({ patientName: "", date: "", hour: "", minute: "", notes: "" });
    setPendingPhotos([]);
    if (initialData) {
      setName(initialData.name || "");
      setAssistantName(initialData.assistantName || "");
      setDoctorName(initialData.doctorName || "");
      setTypeOfWork(initialData.typeOfWork || "");
      setLaboratorio(initialData.laboratorio || "");
      setDueDate(initialData.dueDate ? initialData.dueDate.split("T")[0] : "");
      setNotes(initialData.notes || "");
      setCor2(initialData.cor2 || "");
      setCor(initialData.cor || "");
      setMaterial2(initialData.material2 || "");
      setMaterial(initialData.material || "");
      setdentes(initialData.dentes || "");
      setTipoDentes(initialData.tipoDentes || "");
      setSoftware(initialData.software || "");
      setExternalDetails(initialData.externalDetails || "");
      setGoteiraType(initialData.goteiraType || "");
      setExistingPhotos(initialData.photos || []);
    } else {
      setName(""); setAssistantName(""); setDoctorName(""); setTypeOfWork("");
      setLaboratorio(""); setDueDate(""); setNotes(""); setMaterial2("");
      setMaterial(""); setdentes(""); setTipoDentes(""); setSoftware("");
      setCor(""); setCor2(""); setExternalDetails(""); setGoteiraType("");
      setExistingPhotos([]);
    }
  }, [initialData, isOpen]);

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setPendingPhotos((prev) => [...prev, ...files]);
    e.target.value = "";
  };

  const removePending = (index) => {
    setPendingPhotos((prev) => prev.filter((_, i) => i !== index));
  };

  const deleteExistingPhoto = async (photo) => {
    if (!initialData?._id) return;
    try {
      const encodedId = encodeURIComponent(photo.publicId);
      const response = await axios.delete(`${API}/patients/${initialData._id}/photos/${encodedId}`);
      setExistingPhotos(response.data.photos || []);
    } catch (error) {
      console.error("Error deleting photo:", error);
    }
  };

  const handlePatientSubmit = async (e) => {
    e.preventDefault();
    if (
      !name || !assistantName || !doctorName || !typeOfWork || !laboratorio ||
      (typeOfWork === "coroa" && !material) ||
      (typeOfWork === "coroa" && !cor) ||
      (typeOfWork === "prótese fixa" && !cor2) ||
      (typeOfWork === "prótese fixa" && !material2) ||
      (laboratorio === "externo" && !externalDetails) ||
      (typeOfWork === "Encerado Diagnostico" && laboratorio === "interno" && !dentes) ||
      (typeOfWork === "Encerado Diagnostico" && laboratorio === "interno" && !tipoDentes) ||
      (typeOfWork === "goteiras" && laboratorio === "interno" && !goteiraType) ||
      (typeOfWork === "Encerado Diagnostico" && laboratorio === "interno" && tipoDentes === "Foto para mostrar ao paciente" && !software)
    ) {
      alert("Necessita todos os campos preenchidos.");
      return;
    }

    const patientData = {
      name, assistantName, doctorName, typeOfWork, laboratorio, dueDate, notes,
      cor: typeOfWork === "coroa" ? cor : "",
      cor2: typeOfWork === "prótese fixa" ? cor2 : "",
      material: typeOfWork === "coroa" ? material : "",
      material2: typeOfWork === "prótese fixa" ? material2 : "",
      dentes: typeOfWork === "Encerado Diagnostico" ? dentes : "",
      tipoDentes: typeOfWork === "Encerado Diagnostico" ? tipoDentes : "",
      software: (typeOfWork === "Encerado Diagnostico" && tipoDentes === "Foto para mostrar ao paciente") ? software : "",
      externalDetails: laboratorio === "externo" ? externalDetails : "",
      goteiraType: typeOfWork === "goteiras" && laboratorio === "interno" ? goteiraType : "",
    };

    try {
      let patientId;

      if (initialData && initialData._id) {
        await axios.put(`${API}/patients/${initialData._id}`, patientData);
        patientId = initialData._id;
      } else {
        const response = await axios.post(`${API}/patients`, { ...patientData, entryTime: new Date() });
        patientId = response.data._id;
      }

      // Upload pending photos if any
      if (pendingPhotos.length > 0) {
        setUploadingPhotos(true);
        const formData = new FormData();
        pendingPhotos.forEach((file) => formData.append("photos", file));
        await axios.post(`${API}/patients/${patientId}/photos`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setUploadingPhotos(false);
      }

      onRequestClose();
      fetchPatients();
    } catch (error) {
      console.error("Error saving patient:", error);
      setUploadingPhotos(false);
    }
  };

  const handleConcertoSubmit = async () => {
    if (!concertoForm.patientName || !concertoForm.date || !concertoForm.hour || !concertoForm.minute) return;
    const h = concertoForm.hour.padStart(2, "0");
    const m = concertoForm.minute.padStart(2, "0");
    const dateTime = new Date(`${concertoForm.date}T${h}:${m}`).toISOString();
    try {
      await axios.post(`${API}/appointments`, {
        patientName: concertoForm.patientName,
        dateTime,
        notes: concertoForm.notes,
      });
      if (fetchAppointments) fetchAppointments();
      onRequestClose();
    } catch (error) {
      console.error("Error saving concerto:", error);
    }
  };

  const isEditing = !!(initialData && initialData._id);

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      {!isEditing && (
        <div className="patient-form-tabs">
          <button
            className={`patient-form-tab ${activeTab === "geral" ? "active" : ""}`}
            onClick={() => setActiveTab("geral")}
            type="button"
          >
            Geral
          </button>
          <button
            className={`patient-form-tab ${activeTab === "concerto" ? "active" : ""}`}
            onClick={() => setActiveTab("concerto")}
            type="button"
          >
            Concerto
          </button>
        </div>
      )}

      {(isEditing || activeTab === "geral") && (
        <form onSubmit={handlePatientSubmit}>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome do Paciente" required />
          <select value={assistantName} onChange={(e) => setAssistantName(e.target.value)}>
            <option value="">Assistente:</option>
            <option value="Filipa">Filipa</option>
            <option value="Bruna">Bruna</option>
            <option value="Sandra">Sandra</option>
            <option value="Patrícia">Patrícia</option>
            <option value="Lara">Lara</option>
            <option value="Claudia">Claudia</option>
            <option value="Carlota">Carlota</option>
          </select>
          <select value={doctorName} onChange={(e) => setDoctorName(e.target.value)}>
            <option value="">Doutor(a)</option>
            <option value="JP">JP</option>
            <option value="Ricardo">Ricardo</option>
            <option value="Sónia">Sónia</option>
            <option value="João Pinto">João Pinto</option>
            <option value="Marta Vale">Marta Vale</option>
            <option value="Ana Marques">Ana Marques</option>
            <option value="Miguel Pessanha">Miguel Pessanha</option>
          </select>
          <select value={typeOfWork} onChange={(e) => setTypeOfWork(e.target.value)}>
            <option value="">Tipo de trabalho</option>
            <option value="prótese removível">Prótese removível</option>
            <option value="prótese fixa">Prótese fixa</option>
            <option value="goteiras">Goteiras</option>
            <option value="coroa">Coroa(s)</option>
            <option value="Ortodontia">Ortodontia</option>
            <option value="Encerado Diagnostico">Encerado Diagnostico</option>
            <option value="urgência">Urgência</option>
          </select>
          {typeOfWork === "coroa" && (
            <select value={material} onChange={(e) => setMaterial(e.target.value)}>
              <option value="">Material:</option>
              <option value="Zirconia">Zirconia</option>
              <option value="PPMA">PPMA</option>
              <option value="Resina">Resina</option>
              <option value="Cerec">Cerec</option>
              <option value="Feldspatica">Feldspatica</option>
            </select>
          )}
          {typeOfWork === "prótese fixa" && (
            <select value={material2} onChange={(e) => setMaterial2(e.target.value)}>
              <option value="">Material:</option>
              <option value="Zirconia">Zirconia</option>
              <option value="PPMA">PPMA</option>
              <option value="Resina">Resina</option>
              <option value="Cerec">Cerec</option>
              <option value="Feldspatica">Feldspatica</option>
              <option value="Grafeno">Grafeno</option>
            </select>
          )}
          {typeOfWork === "coroa" && (
            <input type="text" value={cor} onChange={(e) => setCor(e.target.value)} placeholder="Cor:" />
          )}
          {typeOfWork === "prótese fixa" && (
            <input type="text" value={cor2} onChange={(e) => setCor2(e.target.value)} placeholder="Cor:" />
          )}
          <select value={laboratorio} onChange={(e) => setLaboratorio(e.target.value)} required>
            <option value="">Laboratorio</option>
            <option value="interno">Interno</option>
            <option value="externo">Externo</option>
          </select>
          {laboratorio === "externo" && (
            <input type="text" value={externalDetails} onChange={(e) => setExternalDetails(e.target.value)} placeholder="Qual?" />
          )}
          {typeOfWork === "goteiras" && laboratorio === "interno" && (
            <select value={goteiraType} onChange={(e) => setGoteiraType(e.target.value)}>
              <option value="">Tipo de Goteira:</option>
              <option value="Goteira de Proteção">Goteira de Proteção</option>
              <option value="Goteira de Michigan">Goteira de Michigan</option>
              <option value="Goteira Cirúrgica">Guia Cirúrgica</option>
              <option value="Goteira Branqueamento">Goteira de Branqueamento</option>
            </select>
          )}
          {typeOfWork === "Encerado Diagnostico" && laboratorio === "interno" && (
            <input type="text" value={dentes} onChange={(e) => setdentes(e.target.value)} placeholder="Quais Dentes?:" />
          )}
          {typeOfWork === "Encerado Diagnostico" && laboratorio === "interno" && (
            <select value={tipoDentes} onChange={(e) => { setTipoDentes(e.target.value); setSoftware(""); }}>
              <option value="">O que é para fazer?:</option>
              <option value="Para fazer muralha">Para fazer muralha</option>
              <option value="Foto para mostrar ao paciente">Foto para mostrar ao paciente</option>
            </select>
          )}
          {typeOfWork === "Encerado Diagnostico" && laboratorio === "interno" && tipoDentes === "Foto para mostrar ao paciente" && (
            <select value={software} onChange={(e) => setSoftware(e.target.value)}>
              <option value="">Software:</option>
              <option value="Exocad">Exocad</option>
              <option value="Smilecloud">Smilecloud</option>
            </select>
          )}
          <label htmlFor="dueDate">Prazo de Entrega:</label>
          <input type="date" id="dueDate" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Notas (Opcional)" />

          {/* ── Photos section ── */}
          <div className="photo-upload-section">
            {/* Existing photos (edit mode) */}
            {existingPhotos.map((photo) => (
              <div key={photo.publicId} className="photo-row">
                <span className="photo-name">📎 {photo.name}</span>
                <button
                  type="button"
                  className="photo-remove-btn"
                  onClick={() => deleteExistingPhoto(photo)}
                  title="Eliminar foto"
                >
                  ✕
                </button>
              </div>
            ))}

            {/* Pending photos (not yet uploaded) */}
            {pendingPhotos.map((file, index) => (
              <div key={index} className="photo-row photo-row-pending">
                <span className="photo-name">📎 {file.name}</span>
                <button
                  type="button"
                  className="photo-remove-btn"
                  onClick={() => removePending(index)}
                  title="Remover"
                >
                  ✕
                </button>
              </div>
            ))}

            <input
              type="file"
              ref={fileInputRef}
              multiple
              accept="image/*,.pdf"
              style={{ display: "none" }}
              onChange={handleFileSelect}
            />
            <button
              type="button"
              className="photo-add-btn"
              onClick={() => fileInputRef.current.click()}
            >
              + Adicionar Fotografias
            </button>
          </div>

          <button type="submit" disabled={uploadingPhotos}>
            {uploadingPhotos ? "A carregar fotos..." : "Guardar"}
          </button>
        </form>
      )}

      {!isEditing && activeTab === "concerto" && (
        <div className="agenda-modal-form" style={{ marginTop: 10 }}>
          <label>Nome do Paciente</label>
          <input
            type="text"
            value={concertoForm.patientName}
            onChange={(e) => setConcertoForm({ ...concertoForm, patientName: e.target.value })}
            placeholder="Nome"
          />
          <label>Data</label>
          <input
            type="date"
            value={concertoForm.date}
            onChange={(e) => setConcertoForm({ ...concertoForm, date: e.target.value })}
          />
          <label>Hora</label>
          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            <input
              type="number" min="0" max="23"
              value={concertoForm.hour}
              onChange={(e) => setConcertoForm({ ...concertoForm, hour: e.target.value })}
              placeholder="HH"
              style={{ width: "55px" }}
            />
            <span style={{ fontWeight: 700, fontSize: "16px" }}>:</span>
            <input
              type="number" min="0" max="59"
              value={concertoForm.minute}
              onChange={(e) => setConcertoForm({ ...concertoForm, minute: e.target.value })}
              placeholder="MM"
              style={{ width: "55px" }}
            />
          </div>
          <label>Notas (opcional)</label>
          <input
            type="text"
            value={concertoForm.notes}
            onChange={(e) => setConcertoForm({ ...concertoForm, notes: e.target.value })}
            placeholder="Notas"
          />
          <div className="agenda-modal-actions">
            <button className="agenda-modal-cancel" type="button" onClick={onRequestClose}>Cancelar</button>
            <button className="agenda-modal-save" type="button" onClick={handleConcertoSubmit}>Guardar</button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PatientForm;